(function () {
  function boot() {
    document.querySelectorAll('.spb--animated').forEach((el) => {
      requestAnimationFrame(() => el.classList.add('is-in'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
